import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { VolunteeringProspectsService } from '../volunteering-prospects.service';
import { AllClosedViewPart } from './all-closed/all-closed.part';
import { PotentialVolunteersViewPart } from './potential-volunteers/potential-volunteers.part';
import { RecentlyClosedViewPart } from './recently-closed/recently-closed.part';

@Component({
	selector: 'volunteering-prospects-views-part',
	standalone: true,
	imports: [
		PotentialVolunteersViewPart,
		RecentlyClosedViewPart,
		AllClosedViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-prospects-views.part.html',
})

export class VolunteeringProspectsViewsPart implements OnInit {

	public service = inject(VolunteeringProspectsService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}